export default __webpack_public_path__ + "static/media/doc.4872f9f0.svg";